module.exports = __webpack_public_path__ + "img/apartment_dialog_icon05.36533f7d.png";